// 全局 polyfills 设置
import {Buffer} from 'buffer';
import process from 'process/browser';

// 设置全局变量
if (typeof global === 'undefined') {
  var global = globalThis;
}

// Buffer polyfill
global.Buffer = Buffer;
window.Buffer = Buffer;

// Process polyfill
global.process = process;
window.process = process;

// 确保 global 指向正确的对象
global.global = global;
window.global = global;

// zlib 模拟
if (!global.zlib) {
  global.zlib = {
    constants: {
      Z_SYNC_FLUSH: 2,
      Z_FULL_FLUSH: 3,
      Z_FINISH: 4,
      Z_NO_COMPRESSION: 0,
      Z_BEST_SPEED: 1,
      Z_BEST_COMPRESSION: 9,
      Z_DEFAULT_COMPRESSION: -1,
      Z_FILTERED: 1,
      Z_HUFFMAN_ONLY: 2,
      Z_RLE: 3,
      Z_FIXED: 4,
      Z_DEFAULT_STRATEGY: 0
    }
  };
}

// vm 模块模拟
if (!global.vm) {
  global.vm = {};
}

console.log('Polyfills loaded successfully');
